import { ChakraProvider, createSystem, defaultConfig } from "@chakra-ui/react"
import { ReactNode } from "react"
import { ColorModeProvider } from "./color-mode"

interface ProviderProps {
  children: ReactNode
}

const system = createSystem(defaultConfig, {
  theme: {
    tokens: {
      colors: {
        gray: {
          50: { value: "#f9fafb" },
          100: { value: "#f3f4f6" },
          200: { value: "#e5e7eb" },
          300: { value: "#d1d5db" },
          400: { value: "#9ca3af" },
          500: { value: "#6b7280" },
          600: { value: "#4b5563" },
          700: { value: "#374151" },
          800: { value: "#1f2937" },
          900: { value: "#111827" }
        }
      }
    },
    semanticTokens: {
      colors: {
        bg: {
          default: { value: "{colors.white}" },
          _dark: { value: "{colors.gray.900}" }
        },
        cardBg: {
          default: { value: "{colors.white}" },
          _dark: { value: "{colors.gray.800}" }
        },
        border: {
          default: { value: "{colors.gray.200}" },
          _dark: { value: "{colors.gray.600}" }
        },
        text: {
          default: { value: "{colors.gray.900}" },
          _dark: { value: "{colors.gray.100}" }
        },
        textMuted: {
          default: { value: "{colors.gray.600}" },
          _dark: { value: "{colors.gray.400}" }
        }
      }
    }
  }
})

export function Provider({ children }: ProviderProps) {
  return (
    <ChakraProvider value={system}>
      <ColorModeProvider>
        {children}
      </ColorModeProvider>
    </ChakraProvider>
  )
}
